import { v4 as uuid } from 'uuid';
import type { IAccountGatewayAccreditation } from './AccountGatewayAccreditation.interface';
import { toUUID } from '../../util/transform';

export default class AccountGatewayAccreditation implements IAccountGatewayAccreditation {
  id: string;
  idGateway: string;
  brokerUsername: string;
  brokerPassword: string;

  static build = (data: IAccountGatewayAccreditation) => new AccountGatewayAccreditation(data);
  static blank = () => new AccountGatewayAccreditation();

  /**
   * Constructor
   * @param {IAccountGatewayAccreditation} data
   */
  constructor(data?: IAccountGatewayAccreditation) {
    this.id = toUUID(data?.id) || uuid();
    this.idGateway = data?.idGateway || undefined;
    this.brokerUsername = data?.brokerUsername || undefined;
    this.brokerPassword = data?.brokerPassword || undefined;
  }
}
